import React, { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import { Typography,Box ,Grid} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useForm, Controller } from 'react-hook-form';
import { getOtp } from 'redux/actions/authAction';
import { companyDetails } from 'utils/companyDetails';
import { getBranding } from 'config/tenantConfig';
import Timer from './Timer';
import QuoteImg from 'assets/images/QuoteImg.svg';

function Otp(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userOtp = useSelector((state) => state);
  const isLoader = userOtp?.auth?.loading;
  const mobile = localStorage.getItem('mobile');
  const otpSuccess = userOtp?.auth?.isAuth
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();
  const [errorOtp, setErrorOtp] = useState('');
  const [autoFocusOtp, setAutoFocusOtp] = useState(true);

  const onSubmit = (data) => {
    // Handle form submission
    const mobile = localStorage.getItem('mobile');

    const otpDetails = {
      platform: 'FrontDeskApp',
      mobileOrEmail: mobile,
      otp: data,
      countryCode: '+91',
    };
    dispatch(getOtp(otpDetails, navigate));
  };

  const onBackBtn = () => {
    localStorage.clear();
    props?.onOtpPage(false);
  };

  // ---Check Wheather mobile is present or not----
  useEffect(() => {
    const mobile = localStorage.getItem('mobile');
    if (!mobile) {
      navigate('/login');
    }
  }, []);

  useEffect(() => {
    if(isLoader){
      setAutoFocusOtp(false)
    }else{
      if(!otpSuccess){
        setAutoFocusOtp(true)
        reset();
        setErrorOtp("");
      }
    }
  }, [isLoader]);

  const handleOtpChange = (value) => {
    const validateNumber =
      parseInt(value) || parseInt(value) === 0 ? true : false;
    if (!validateNumber) {
      setErrorOtp('OTP must contain only numbers');
    } else if (value.length === 4 && validateNumber) {
      onSubmit(value);
    } else {
      setErrorOtp('');
    }
  };

  const onResend = () => {
    reset();
    setErrorOtp("");
  }

  return (
    <div>
      <Box sm={{ flexGrow: 1 }} className="mobileRes height100 loginMain">
        <Grid container className="justifyCenter">
          {/* ---login Part--- */}
          <Grid item sm={6}>
            {/* ---login nav--- */}
            <Box
              sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center' }}
              className="backArrow-icon"
            >
              <ArrowBackIcon
                onClick={() => {
                  onBackBtn();
                }}
                role="presentation"
              />
            </Box>

            {/* ---OTP input type--- */}
            <div className="loginInput mobileBg">
              <Grid
                container
                className="height100 justifyCenter"
              >
                <Grid
                  item
                  sm={7}
                  container
                  flexDirection={'column'}
                  alignItems={'flex-start'}
                  justifyContent={'center'}
                >
                  <Box className="mb20">
                    <img src={getBranding().logo || companyDetails?.companyLogo} className="logoImg" alt="otplogo" />
                  </Box>
                  <Box sx={{ paddingLeft: { xs: '0px', sm: '10px' } }}>
                    <Typography className="fw700 font36 colorPrimary pb20">
                      <span className="colorYellow">Verify</span>
                      <span className="bottomDivider"></span>
                    </Typography>
                    <Box>
                      <Typography variant="body1" className="colorGrey fw400">
                        An authentication {companyDetails?.companyName} code has been sent to
                      </Typography>
                      <Typography
                        variant={'body2'}
                        className="colorBlack fw400"
                      >
                        {mobile}
                      </Typography>
                    </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      {/* ---OTP UI--- */}
                      <Grid
                        sx={{ marginTop: { xs: '20px', sm: '40px' } }}
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={1}
                      >
                        <Grid item sm={9} className="otpInput">
                          <Controller
                            name="otp"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: 'OTP is required',
                              minLength: {
                                value: 4,
                                message: 'OTP must be 4 characters long',
                              },
                            }}
                            render={({ field }) => (
                              <OtpInput
                                containerStyle="otp"
                                inputStyle={
                                  errors.otp ? 'otpStyleError' : 'otpStyle'
                                }
                                value={field.value}
                                inputType='tel'
                                onChange={(value) => {
                                  field.onChange(value);
                                  handleOtpChange(value);
                                }}
                                numInputs={4}
                                renderInput={(props) => (
                                  <input {...props} disabled={isLoader} />
                                )}
                                shouldAutoFocus={autoFocusOtp}
                              />
                            )}
                          />
                          {errorOtp && (
                            <p className="errorOtp justifyCenter">
                              <span>
                                <ErrorIcon />
                              </span>
                              {errorOtp}
                            </p>
                          )}
                        </Grid>
                        <Grid
                          container
                          item
                          sm={8}
                          justifyContent="center"
                          className="otpInput"
                        >
                          {/* ---Timer Screen--- */}
                          <Grid item>
                            <div>
                              <Timer onResend={onResend}/>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </form>
                  </Box>
                </Grid>
              </Grid>
            </div>
          </Grid>
          {/* ---Image Part--- */}
          <Grid
            item
            sm={6}
            sx={{ display: { xs: 'none', sm: 'flex' } }}
            className="bgImage"
          >
            <Box className="loginBgImg height100">
              <Box className="justifyCenter height100">
                <Box className="justifyCenter">
                  <Box
                    className="flexDisplay alignFlexStart"
                    flexDirection={'column'}
                  >
                    <img src={QuoteImg} alt="quoteImg" className="quoteImg" />
                    <Typography className="colorWhite fw300" variant={'head2'}>
                      Innovate, Collaborate,
                      <br />
                      Prosper: Redefine Possibilities
                      <br />
                      with our <span className="fw600">{companyDetails?.companyName}</span> Initiative
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Otp;
